// departamentosColombia.js — los 32 departamentos + Bogotá D.C., con el código ISO-3166-2:CO
// («CO-XXX»). ESE es el formato que usa el checkout de la tienda en Woo (medido en prod, 26-sep:
// el 50,7% de los `state` son CO-XXX y es lo que escribe el checkout nativo; el 48,8% restante son
// códigos cortos legacy de 3 letras que escribía Neto). El desplegable de «Departamento» GUARDA
// CO-XXX para alinear con el checkout; un valor que no esté en la lista se conserva tal cual.

export const DEPARTAMENTOS = [
  { nombre: 'Amazonas', codigo: 'CO-AMA' },
  { nombre: 'Antioquia', codigo: 'CO-ANT' },
  { nombre: 'Arauca', codigo: 'CO-ARA' },
  { nombre: 'Atlántico', codigo: 'CO-ATL' },
  { nombre: 'Bogotá D.C.', codigo: 'CO-DC' },
  { nombre: 'Bolívar', codigo: 'CO-BOL' },
  { nombre: 'Boyacá', codigo: 'CO-BOY' },
  { nombre: 'Caldas', codigo: 'CO-CAL' },
  { nombre: 'Caquetá', codigo: 'CO-CAQ' },
  { nombre: 'Casanare', codigo: 'CO-CAS' },
  { nombre: 'Cauca', codigo: 'CO-CAU' },
  { nombre: 'Cesar', codigo: 'CO-CES' },
  { nombre: 'Chocó', codigo: 'CO-CHO' },
  { nombre: 'Córdoba', codigo: 'CO-COR' },
  { nombre: 'Cundinamarca', codigo: 'CO-CUN' },
  { nombre: 'Guainía', codigo: 'CO-GUA' },
  { nombre: 'Guaviare', codigo: 'CO-GUV' },
  { nombre: 'Huila', codigo: 'CO-HUI' },
  { nombre: 'La Guajira', codigo: 'CO-LAG' },
  { nombre: 'Magdalena', codigo: 'CO-MAG' },
  { nombre: 'Meta', codigo: 'CO-MET' },
  { nombre: 'Nariño', codigo: 'CO-NAR' },
  { nombre: 'Norte de Santander', codigo: 'CO-NSA' },
  { nombre: 'Putumayo', codigo: 'CO-PUT' },
  { nombre: 'Quindío', codigo: 'CO-QUI' },
  { nombre: 'Risaralda', codigo: 'CO-RIS' },
  { nombre: 'San Andrés y Providencia', codigo: 'CO-SAP' },
  { nombre: 'Santander', codigo: 'CO-SAN' },
  { nombre: 'Sucre', codigo: 'CO-SUC' },
  { nombre: 'Tolima', codigo: 'CO-TOL' },
  { nombre: 'Valle del Cauca', codigo: 'CO-VAC' },
  { nombre: 'Vaupés', codigo: 'CO-VAU' },
  { nombre: 'Vichada', codigo: 'CO-VID' },
];

const norm = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
const POR_NOMBRE = new Map(DEPARTAMENTOS.map((d) => [norm(d.nombre), d.codigo]));
const CODIGOS = new Set(DEPARTAMENTOS.map((d) => d.codigo));
// Formato CORTO legacy de 3 letras que también escribió Neto (medido en prod, 48,8%). Para casi
// todos el corto = el sufijo ISO (ANT↔CO-ANT); la EXCEPCIÓN es Bogotá (corto «BOG», ISO «CO-DC»).
// Se deriva del sufijo, con el override de Bogotá. Sirve para RECONOCER y MOSTRAR el nombre.
const CORTO_A_CODIGO = new Map(DEPARTAMENTOS.map((d) => [d.codigo === 'CO-DC' ? 'bog' : norm(d.codigo.slice(3)), d.codigo]));
const CODIGO_A_NOMBRE = new Map(DEPARTAMENTOS.map((d) => [d.codigo, d.nombre]));

// Devuelve el código CO-XXX de un valor que puede venir como NOMBRE («Antioquia», de
// CityAutocomplete) o ya como código. Si no se reconoce (código corto legacy «ANT», texto raro),
// devuelve el valor TAL CUAL — nunca se inventa ni se borra (decisión 2b: preservar lo desconocido).
export function codigoDepartamento(valor) {
  const v = String(valor || '').trim();
  if (!v) return '';
  if (CODIGOS.has(v)) return v;               // ya es CO-XXX
  const porNombre = POR_NOMBRE.get(norm(v));
  return porNombre || v;                       // nombre conocido → código; si no, tal cual
}

// ¿El valor guardado corresponde a un código ISO conocido (CO-XXX)? (para saber si el <select>
// lo selecciona con una opción estándar o hay que mostrar el valor crudo como opción aparte).
export function esCodigoConocido(valor) {
  return CODIGOS.has(String(valor || '').trim());
}

// Nombre para MOSTRAR de un valor de `state` que puede venir como código ISO (CO-ANT), corto
// legacy (ANT), o nombre (Antioquia). Devuelve '' si no se reconoce (se muestra el crudo). Esto
// NO cambia el valor guardado — sólo el rótulo; el valor sólo migra a CO-XXX si el usuario elige.
export function nombreDepartamento(valor) {
  const v = String(valor || '').trim();
  if (!v) return '';
  if (CODIGO_A_NOMBRE.has(v)) return CODIGO_A_NOMBRE.get(v);      // CO-XXX
  const porCorto = CORTO_A_CODIGO.get(norm(v));
  if (porCorto) return CODIGO_A_NOMBRE.get(porCorto);            // corto legacy (ANT, BOG…)
  const porNombre = POR_NOMBRE.get(norm(v));
  if (porNombre) return CODIGO_A_NOMBRE.get(porNombre);          // ya es un nombre
  return '';                                                     // desconocido → el crudo se muestra tal cual
}
